import { NQInternalErrorCode } from "@visonum/network-quality-sdk/dist/src/main/NQError";

export const errorInternalCodeToString = (code: NQInternalErrorCode): string => {
    switch (code) {
        case NQInternalErrorCode.RemotePortDetection: return "RemotePortDetection";
        case NQInternalErrorCode.MissingNQValueDuringSave: return "MissingNQValueDuringSave";
        case NQInternalErrorCode.IllegalBenchmarkResultsValues: return "IllegalBenchmarkResultsValues";
        case NQInternalErrorCode.DownloadError: return "DownloadError";
        case NQInternalErrorCode.DownloadTimeout: return "DownloadTimeout";
        case NQInternalErrorCode.UploadError: return "UploadError";
        case NQInternalErrorCode.UploadTimeout: return "UploadTimeout";
    }
}

export default errorInternalCodeToString;